<template>
  <footer v-if="list_pages">
    <div class="row">
      <div class="col-md-4">
        <ul>
          <li v-for="item in list_pages" :key="item.id">
            <router-link :to="{ name: 'Page', params: { slug: item.slug } }">
              {{ item.title }}
            </router-link>
          </li>
        </ul>
      </div>
      <div class="col-md-4">
        <div v-html="contact.description"></div>
      </div>
      <div class="col-md-4">

          <div v-html="connectsocial.description"></div>

        <!--<img src="/static/images/bo-cong-thuong.png" width="100" />-->
      </div>
    </div>
  </footer>
</template>
<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'
export default {
  name: 'Footer',
  components: {},
  data () {
    return {
      list_pages: null
    }
  },
  methods: {},
  mounted () {
    Utils.requestV2(this, true)
      .get(`/posts?section=footer`)
      .then((response) => {
        // console.log('response post',response)
        if (response.data) {
          let list_pages = response.data
          // console.log('list_pages',list_pages)

          this.list_pages = list_pages.filter(item => {
            return item.code === ''
          })
          let temp = list_pages.filter(item => {
            return item.code === 'contact'
          })
          if (temp.length === 1) {
            this.contact = temp[0]
          }
          temp = list_pages.filter(item => {
            return item.code === 'connectsocial'
          })
          if (temp.length === 1) {
            this.connectsocial = temp[0]
          }
        }
      })
      .catch((error) => {
        this.updating = false
        Utils.showErrorMessage(this, error.response)
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Layout/Footer.vue